module.exports = __webpack_public_path__ + "static/media/solution-front.a714c722.svg";